<template>
    <div>
        <div class="top_box">
            <h2>未启动救援案件列表</h2>
            <div class="time_box">
                <div class="block st_box">
                    起始时间
                    <el-date-picker
                    @change="sttime()"
                    v-model="st_time"
                    align="right"
                    type="date"
                    placeholder="起始时间"
                    :picker-options="pickerOptions1">
                    </el-date-picker>
                </div>
                <div class="block en_box">
                    结束时间
                    <el-date-picker
                    @change="entime()"
                    v-model="en_time"
                    align="right"
                    type="date"
                    placeholder="结束时间"
                    :picker-options="pickerOptions1">
                    </el-date-picker>
                </div>
                <div class="block en_box">
                    案件编号：
                    <el-input style="display: inline-block;width: 220px;" @change="sttime()" v-model="caseNumber" placeholder="请输入案件编号"></el-input>
                </div>
                 <div class="block en_box">
                    保单号：
                     <el-input style="display: inline-block;width: 220px;" @change="sttime()" v-model="victimPolicyNo" placeholder="请输入内容"></el-input>
                </div>
                  <div class="block en_box">
                    被保险人：
                     <el-input style="display: inline-block;width: 220px;" @change="sttime()"  v-model="victimUser" placeholder="请输入内容"></el-input>
                </div>
                  <div class="block en_box" style="margin-left:0px">
                    证件信息：
                     <el-input style="display: inline-block;width: 220px;" @change="sttime()"  v-model="victimNational" placeholder="请输入内容"></el-input>
                </div>
           
        
       </div>
       <div class="time_box" style="margin-bottom:15px">
      
                <div class="block">
                  <el-button type="primary" @click="filt()">查询</el-button>
                </div>
            </div>
        </div>
        <!-- <formVue :token="token" :st_time="st_time" :en_time="en_time" :flag="flag" :sereen="sereen" :typeId="typeId" :victimUser="victimUser" :victimPolicyNo="victimPolicyNo" :victimNational="victimNational"/> -->
         <div class="form_box">
    <el-table empty-text="暂无数据" :data="tableData" border>
      <el-table-column prop="number" label="序号" min-width="50%">
      </el-table-column>
      <el-table-column prop="casenumber" label="案件编号" min-width="80">
        <!-- <template slot-scope="scope">
            {{scope.row.casenumber}}
            <span v-if="scope.row.subRegulatorId != null && scope.row.subRegulatorId != '' && scope.row.subRegulatorId != undefined">({{scope.row.subRegulatorId}})</span>
          </template>
        </el-table-column> -->
      </el-table-column>
      <el-table-column prop="address" label="发生地点" min-width="100%">
      </el-table-column>
      <el-table-column prop="username" label="用户姓名" min-width="50%">
      </el-table-column>
      <el-table-column prop="phone" label="用户手机号" min-width="70%">
      </el-table-column>
      <el-table-column prop="papers" label="证件信息" min-width="70%">
      </el-table-column>
      <el-table-column prop="sex" label="性别" min-width="40%">
      </el-table-column>
      <el-table-column prop="time" label="出险时间" min-width="90%">
      </el-table-column>
      <el-table-column prop="par" label="用户保险详情" min-width="70%">
        <template slot-scope="scope">
          <el-button type="text" size="small" v-show="scope.row.isshow" @click="toUrl(scope.row.insuranceUrl)">保险详情</el-button>
          <el-button type="text" size="small" v-show="!scope.row.isshow">无</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="plan" label="当前进度" min-width="80%">
      </el-table-column>
      <el-table-column prop="el" label="其他" min-width="90%">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="dialogVisible=true;closeId=scope.row.caseId">关闭当前案件</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="op" label="操作" min-width="90%">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="tostatr(scope.$index,scope.row)">启动救援</el-button>
          <el-button type="text" size="small" @click="topar(scope.row.initialCaseId)">案件详情</el-button>
        </template>
      </el-table-column>
    </el-table>
<el-pagination
      style="margin-top: 15px;float: right;"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage4"
      :page-sizes="[10]"
      :page-size="10"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
      <span>确认关闭？</span>
      <textarea placeholder="请输入关闭原因" v-model="closeTxt" class="closeTxt"></textarea>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false;closeCase(closeId)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
    </div>
</template>

<script>
import formVue from "./form.vue";
 import {
    Message
  } from "element-ui";
  import err from "@/util/error2msg.js";
  import constants from '@/util/constants.js';
import {closeOrdinaryCase } from '@/views/axios/api.js'
export default {
  data() {
    return {
      itemcaseId:'',
       start:0,
        count:10,
        total:0,
        currentPage4: 1,
      tableData: [],
        obj: [],
        victimList: [],
        dialogVisible:false,
        closeId:'',
        closeTxt:'',
       victimUser:'',
        // victimMobile:'',
        victimPolicyNo:'',
        victimNational:'',
        caseNumber:'',
      insuranceCompanyId:'',
      subRegulatorId:'',
      companies:[],
      companies1:[],
      sereen: false,
      token:
        this.$route.params.token ||
        JSON.parse(window.localStorage.getItem("data")).data,
      st_time: "",
      typeId: this.$route.query.typeId,
      en_time: "",
      flag: this.$route.params.flag,
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      }
    };
  },
  components: {
    // formVue
  },
  methods: {
      handleSizeChange(val) {
         this.count = val
             this.getData()
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        this.start = (val-1) * this.count;
        // this.start = val * 10
            this.getData()
        console.log(`当前页: ${val}`);
      },
    error2msg(errcode) {
        var errmsg = err;
        var msg = errmsg.tomsg(errcode);
        Message.error(msg);
      },
      tostatr(index,item) {
        this.itemcaseId = item.caseId
        console.log(item.caseId)
        if (this.$route.name == 'ComAwait1') {
          this.$router.push({
            name: "helpStart",
            params: {
              token: this.token
            },
            query: {
              typeId: this.typeId,
              caseid: this.itemcaseId,
              refused: 1
            }
          });
        } else {
          this.$router.push({
            name: "helpStart",
            params: {
              token: this.token
            },
            query: {
              typeId: this.typeId,
              caseid: this.itemcaseId
            }
          });
        }

      },
      topar(id) {
      this.$router.push({
        path: '/cmd_center/caseDetails',
        query: {
          caseid: id
        },
      });
        return
        let that = this;
        this.$router.push({
          path: "par",
          name: "ComPar",
          params: {
            token: that.token,
            obj: that.obj,
            victimList: that.victimList,
            index
          },
          query: {
            typeId: this.typeId,
            caseid: this.obj[index].id,
            backto: 0
          }
        });
      },
      closeCase(caseId){
        var data={
          token:this.token,
          caseId
        }
        closeOrdinaryCase(data)
        .then(res => {
          if(res.data.code == 0){
            this.$message.success('案件已关闭')
            this.getData()
          }
        })
        .catch(err => {
          console.log(err);
        })
      },

      toUrl(url) {
        window.open(url);
      },
      getData(st, et) {

        this.tableData = [];
        let that = this;
        let n = 0;
        let sex = "";
        let isshow = false;
        let stTime = st || this.st_time;
        let enTime = et || this.en_time;

        let tl = '';
        if (stTime || enTime) {
          tl = tl + `&startTs=${stTime}&endTs=${enTime}`;
        }
        var body = ''
        if (this.$route.name == 'ComAwait1') {
          console.log(1)
          body = `token=${this.token ||JSON.parse(window.localStorage.getItem("data")).data}&typeId=${this.typeId}&status=170&victimUser=${this.victimUser}&victimPolicyNo=${this.victimPolicyNo}&victimNational=${this.victimNational}&casenumber=${this.caseNumber}&start=${this.start}&count=${this.count}` + tl
        } else {
           console.log(2)
          body = `token=${this.token ||JSON.parse(window.localStorage.getItem("data")).data}&typeId=${this.typeId}&status=100&victimUser=${this.victimUser}&victimPolicyNo=${this.victimPolicyNo}&victimNational=${this.victimNational}&casenumber=${this.caseNumber}&start=${this.start}&count=${this.count}` + tl
        }
        fetch(constants.domain + "rescue/case/list_case", {
            method: "POST",
            body: body,
            mode: "cors",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          })
          .then(function(res) {
            return res.json();
          })
          .then(function(data) {
            
            if (data.code == 0) {
                 that.total = data.total
              data.obj.map(v => {

                n = n + 1;
                if(v.victimList.length != 0){
                  if (v.victimList[0].obj.gender == 1) {
                    sex = "男";
                  } else {
                    sex = "女";
                  }
                  if (v.victimList[0].obj.insurancePolicyNo &&v.victimList[0].obj.insurancePolicyNo != "") {
                    isshow = true;
                  } else {
                    isshow = false;
                  }
                }


                var pt = constants.pt2txt2(v.obj.caseState);
                var address = ''
                if (v.generalLocation) {
                  if (!constants.setTxt(v.generalLocation.addr, 'zh')) {
                    address = v.generalLocation.addr
                  } else {
                    address = that.languageIndex == 0 ? constants.setTxt(v.generalLocation.addr, 'zh') : constants.setTxt(v.generalLocation.addr, 'en')
                  }
                }
                that.tableData.push({
                  number: n, //序号
                  casenumber: v.obj.caseNo, //案件编号
                  caseId:v.obj.id,
				  initialCaseId:v.obj.initialCaseId,
                  address, //地址
                  username: v.victimList[0].obj.victimName, //姓名
                  phone: v.obj.reporterContact, //联系方式
                  papers: v.victimList[0].obj.idNo || "无", //身份证号
                  sex: sex, //性别
                  time: constants.time(v.obj.incidentTs), //出险时间
                  isshow: isshow, //保单
                  insuranceUrl: v.insuranceUrl,
                  plan: pt.phase, //进度
                  get_time: constants.time(v.obj.incidentTs),
                  op: "查看并操作"
                });
                that.obj.push(v.obj);
                that.victimList.push(v.victimList[0]);

              });
            } else {
              that.error2msg(data.code);
            }
          });
      },
    filt() {
      // if (this.st_time && !this.en_time) {
      //   this.sereen = false;
      // } else if (this.en_time && !this.st_time) {
      //   this.sereen = false;
      // } else if (!this.st_time && !this.en_time) {
      //   this.sereen = false;
      // } else {
  
      // }
      this.getData(this.st_time,this.en_time)
     
      
    },
    sttime() {
      this.st_time = this.st_time * 1;
    },
    entime() {
      this.en_time = this.en_time * 1;
      console.log(this.en_time);
    },
    
  },
  mounted() {
      this.getData(this.st_time,this.en_time)
    window.localStorage.setItem(
      "case",
      JSON.stringify({
        case: "ComAwait"
      })
    );
  },

};
</script>

<style scoped>
@import url("../../css/table.css");
</style>


// WEBPACK FOOTER //
// src/components/cmd_center/await.vue